<template>
  <div id="app">
    <LoadingModal v-if="$store.state.LOADING.length > 0" />
    <ErrorModal v-if="$store.state.ERRORS.length > 0" />
    <div class="container">
      <Return />
      <router-view />
    </div>

    <Footer />
  </div>
</template>

<script>
import Return from '@/components/Return'
import Footer from '@/components/Footer'
import LoadingModal from '@/components/LoadingModal'
import ErrorModal from '@/components/ErrorModal'
export default {
  name: 'App',
  components: {
    Return,
    Footer,
    LoadingModal,
    ErrorModal
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/index.scss";

body,
html {
  height: 100%;
}

.container {
  padding: 0 5vw;
}

.bg {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  opacity: .4;
  z-index: -1;
  background: url('https://fcbstudios.com/wwwroot/content/Images/applicationsBg.png');
  /* Create the parallax scrolling effect */
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
}

.modalContainer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, .3);
  z-index: 100;
}

.modal {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: white;
  width: 100%;
  max-width: 600px;
  height: 100vh;
  max-height: 600px;
}

.blackout {
  background-color: rgba(0, 0, 0, 0.4);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;

  display: flex;
  justify-content: center;
  z-index: 99;

  .confirmation-modal {
    background-color: #c2f9ba;
    margin-top: 10vh;
    height: 40vh;
    padding: 2vw;
  }

  .vue-button-holder {
    display: flex;
    justify-content: center;
    margin-top: 5vh;
  }

  a {
    text-decoration: none;
  }

  .back-button {
    background-color: #2B2927;
    color: white;
    padding: 1vw;


    &:hover {
      cursor: pointer;
      background-color: white;
      color: #2B2927
    }
  }
}
</style>